import { render } from "./NotTrainedSellersModal.vue?vue&type=template&id=6e84e9ec"
import script from "./NotTrainedSellersModal.vue?vue&type=script&lang=js"
export * from "./NotTrainedSellersModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./NotTrainedSellersModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_4739e77e%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Ftraining-module%2Fstores-completion%2FNotTrainedSellersModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__